module.exports = ReactChartjs2;